{
	"postTrading": {
		"option": "Опцион",
		"options": "Опционы",
		"stocks": "Акции",
		"sum": "Сумма",
		"price": "Цена",
		"event": "Событие",
		"date": "Дата"
	}
}
